import { getMonthsBetween } from 'ha/helpers/hadate';
import { FilterBuilder } from '../Types';

const minimumStayMonthsBuilder: FilterBuilder = params => {
  return params.startDate && params.endDate
    ? `minimumStayMonths<=${getMonthsBetween(params.startDate, params.endDate)}`
    : '';
};

export default minimumStayMonthsBuilder;
